import baseI18n from "gettext.js";

export const i18n = baseI18n();
